module.exports = __webpack_public_path__ + "img/ranking1.55979a71.png";